import { cachedAPIWrapper } from "../apiCaching/apiWrapper";
import { apiCaching } from "../config/cachingConfig";
import { Carousel } from "../util/infinty-scroll";
import { apiConfig } from "../config/apiConfig";
export class AnimatedTestimonialSection {
  parentElement!: HTMLElement;
  countryId!: 1 | 2;
  conceptId!: string;
  displayStars!: boolean;
  constructor(config: {
    parentElement: HTMLElement;
    countryId: 1 | 2;
    conceptId: string;
    displayStars: boolean;
  }) {
    const { parentElement, conceptId, countryId, displayStars } = config;
    this.displayStars = displayStars;
    this.parentElement = parentElement;
    this.conceptId = conceptId;
    this.countryId = countryId;
    this.init();
  }

  init() {
    const storedWebLocationId = localStorage.getItem("franchiseWebLocationId");
    const webLocationFromElement =
      (document.getElementById("weblocationId") as HTMLInputElement)?.value ||
      "";
    const weblocationId = storedWebLocationId ?? webLocationFromElement;
    const pageNumber = 1,
      pageSize = 30,
      rating = 5;
    const url =
      apiConfig.TESTIMONIAL_REVIEWS +
      `/${this.conceptId}/${weblocationId || 0}/${this.countryId}` +
      `/0/${pageNumber}/${pageSize}/${rating}`;
    this.fetchReviewData(url);
  }

  async fetchReviewData(url: string) {
    try {
      const response = (await cachedAPIWrapper(
        url,
        apiCaching.TestimonyAndReview
      )) as TestimonialData[];
      if (!Array.isArray(response)) {
        console.warn("Invalid testimonial response");
        return;
      }
      this.filterData(response);
    } catch (e) {
      console.warn("Failed to fetch testimonial data", e);
    }
  }

  filterData(response: TestimonialData[]) {
    const validTestimonials = response.filter(
      (item) =>
        item.reviewBody &&
        item.reviewBody.trim().length > 0 &&
        item.reviewBody.length <= 300 &&
        item.reviewAuthorName
    );
    if (validTestimonials.length < 12) {
      const remainingItems = response.filter(
        (item) => !validTestimonials.includes(item) && item.reviewAuthorName
      );
      const additionalItems = remainingItems.slice(
        0,
        12 - validTestimonials.length
      );
      validTestimonials.push(...additionalItems);
    }
    const finalTestimonials = validTestimonials.slice(0, 12);
    const leftContent = finalTestimonials.slice(0, 6);
    const rightContent = finalTestimonials.slice(6);
    this.generateHTML(leftContent, rightContent);
  }

  generateSvgDataUrl(letter: string) {
    const solidColors = [
      "#16a085",
      "#f1c40f",
      "#f39c12",
      "#27ae60",
      "#d35400",
      "#2980b9",
      "#c0392b",
      "#8e44ad",
      "#2c3e50",
    ];
    const randomIndex = new Uint32Array(1);
    window.crypto.getRandomValues(randomIndex);
    const bgColor = solidColors[randomIndex[0] % solidColors.length];
    const text = letter.toUpperCase();

    const svg = `
      <svg xmlns="http://www.w3.org/2000/svg" width="128" height="128">
        <rect width="100%" height="100%" fill="${bgColor}" />
        <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle"
              font-family="sans-serif" font-size="64" fill="#ffffff">
          ${text}
        </text>
      </svg>
    `;

    // Encode and convert to Data URL
    const encoded = encodeURIComponent(svg)
      .replace(/'/g, "%27")
      .replace(/"/g, "%22");

    return `data:image/svg+xml;charset=UTF-8,${encoded}`;
  }

  getReviewerData(data: TestimonialData): TestimonialData {
    const fullName: string = data.reviewAuthorName;
    const processedNameArray = fullName.match(/\b[a-zA-Z]+\b/g) as string[];
    let displayName = fullName;
    if (processedNameArray && processedNameArray.length === 1) {
      displayName = processedNameArray[0];
    }
    if (processedNameArray && processedNameArray.length >= 2) {
      displayName = `${processedNameArray[0]} ${processedNameArray[1]
        .charAt(0)
        .toUpperCase()}.`;
    }
    const newData = {
      ...data,
      reviewAuthorName: displayName,
      reviewBody: data.reviewBody ?? "No review provided.",
    };
    return newData;
  }

  createTemplate = (data: TestimonialData): string => {
    const star = `
        <span class="star full">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240" width="20" height="20">
        <title>Star Icon</title>
        <desc>Star Icon</desc>
        <path fill="#FFC800" d="m48,234 73-226 73,226-192-140h238z"></path>
        </svg>
        </span>
        `;
    const reviewerData = this.getReviewerData(data);
    const generateCard = `
            <div class="card" >
            <div class="testimonial-wrapper">
                    <div class="testimonial-upper-content">
                        <div class="testimonal-client-image">
                            <img src="${reviewerData.reviewPhotoUrl}" 
                            onerror="this.onerror=null; this.src='${this.generateSvgDataUrl(
      reviewerData.reviewAuthorName.charAt(0)
    )}';">
                        </div>
                        <div class="testimonial-name-and-ratings-wrapper">
                            <p class="testimonial-client-name">${reviewerData.reviewAuthorName
      }</p>
                            ${this.displayStars
        ? `<div class="testimonial-ratings">
                                ${star} 
                                ${star} 
                                ${star} 
                                ${star}
                                ${star}
                            </div>`
        : ""
      }
                        </div>
                    </div>
                    <div class="testimonial-description">
                        ${reviewerData.reviewBody}
                    </div>
                </div>
            </div>
            `;
    return generateCard;
  };
  generateHTML(
    leftContent: TestimonialData[],
    rightContent: TestimonialData[]
  ) {
    //left cards
    const leftCards = leftContent.map(this.createTemplate).join("");
    let rightCards =
      this.viewType == "desktop" || this.viewType == "tablet"
        ? rightContent.map(this.createTemplate).join("")
        : null;
    //containers
    const leftCarouselContainer = document.createElement("div");
    const rightCarouselContainer =
      this.viewType == "desktop" || this.viewType == "tablet"
        ? document.createElement("div")
        : null;
    //container config
    leftCarouselContainer.className = "carousel-container";
    leftCarouselContainer.innerHTML = leftCards;
    if (rightCards && rightCarouselContainer) {
      rightCarouselContainer.className = "carousel-container";
      rightCarouselContainer.innerHTML = rightCards;
    }
    //parents
    const leftCarouselParent = document.createElement("div");
    const rightCarouselParent =
      this.viewType == "desktop" || this.viewType == "tablet"
        ? document.createElement("div")
        : null;
    //parents config
    leftCarouselParent.className = "left-carousel-parent";
    leftCarouselParent.appendChild(leftCarouselContainer);
    if (rightCarouselParent && rightCarouselContainer) {
      rightCarouselParent.className = "right-carousel-parent";
      rightCarouselParent.appendChild(rightCarouselContainer);
    }
    //append to div#reviews-animation
    this.parentElement.appendChild(leftCarouselParent);
    if (rightCarouselParent) {
      this.parentElement.appendChild(rightCarouselParent);
    }
    // Initialize and apply infinite scroll animation
    this.applyAnimation(leftCarouselParent, rightCarouselParent);
  }

  applyAnimation(
    leftToRightparent: HTMLElement,
    rightToLeftparent: HTMLElement | null
  ) {
    try {
      //top
      new Carousel({
        delayAfterStop: 30000,
        dragAndScroll: true,
        autoscroll: true,
        infinityScroll: true,
        direction: "right",
        gap: 10,
        parent: leftToRightparent,
        templateName: {
        container: `.reviews-animation > .left-carousel-parent > .carousel-container`,
        card: `.reviews-animation > .left-carousel-parent > .carousel-container > .card`,
      }
      })
      //bottom
      if(rightToLeftparent){
        new Carousel({
          delayAfterStop: 30000,
          dragAndScroll: true,
          autoscroll: true,
          infinityScroll: true,
          direction: "left",
          gap: 10,
          parent: rightToLeftparent,
          templateName: {
          container: `.reviews-animation > .right-carousel-parent > .carousel-container`,
          card: `.reviews-animation > .right-carousel-parent > .carousel-container > .card`,
        }
        })
      }
    } catch (e) {
      console.warn("Failed to apply animation", e);
    }
  }

  get viewType(): "tablet" | "desktop" | "mobile" {
    let view: "tablet" | "desktop" | "mobile" = "desktop";
    if (window.innerWidth < 426) view = "mobile";
    if (window.innerWidth < 781 && window.innerWidth > 425) view = "tablet";
    return view;
  }
}

window.addEventListener("DOMContentLoaded", () => {
  const reviewAnimationElement = document.querySelector(".reviews-animation");
  if (!reviewAnimationElement) return;
  reviewAnimationElement.innerHTML = "";
  const [countryIdElement, conceptIdElement] = document.querySelectorAll(
    "#countryCode, #conceptId"
  );
  if (!countryIdElement || !conceptIdElement) return;
  const countryId =
    (countryIdElement as HTMLInputElement)?.value.toLowerCase() == "us" ? 1 : 2;
  const conceptId = (conceptIdElement as HTMLInputElement).value;
  try {
    new AnimatedTestimonialSection({
      parentElement: reviewAnimationElement as HTMLElement,
      conceptId,
      countryId,
      displayStars: true,
    });
  } catch (e) {
    console.warn("Failed to load testimonial animation", e);
  }
});

type TestimonialData = {
  reviewPhotoUrl: string | null;
  reviewAuthorName: string;
  city?: string;
  reviewStarRating: number;
  reviewSourceType?: string;
  reviewBody?: string;
  reviewResponseBody?: string;
};
